import type { ColumnDef } from '@tanstack/react-table';
import { StackedCellText } from '@/components/common/DataTable';
import { EmptyValue } from '@/components/common/EmptyValue';
import { PersonNameCell } from './PersonNameCell';

const DISTRIBUTOR_NAME_HEADER = 'Distributor Name';

interface RowWithDistributorName {
  name: string;
  userMobile: string | null;
  designationName: string | null;
}

interface RowWithArea {
  divisionName: string | null;
  districtName: string | null;
}

export function getDistributorNameColumn<TRow extends RowWithDistributorName>(
  searchText: string | undefined,
  getNote?: (row: TRow) => string | undefined,
): ColumnDef<TRow, unknown> {
  return {
    id: 'name',
    header: DISTRIBUTOR_NAME_HEADER,
    cell: ({ row }) => (
      <PersonNameCell
        name={row.original.name}
        designationName={row.original.designationName}
        mobile={row.original.userMobile}
        note={getNote?.(row.original)}
        searchText={searchText}
      />
    ),
  };
}

export function getAreaColumn<TRow extends RowWithArea>(): ColumnDef<TRow, unknown> {
  return {
    id: 'area',
    header: 'Area',
    cell: ({ row }) => (
      <StackedCellText
        primary={row.original.divisionName ?? <EmptyValue />}
        secondary={row.original.districtName}
      />
    ),
  };
}
